module.exports = __webpack_public_path__ + "images/emoji/u5408.26304b0f10d34a1bb1f0.png";